import { createApp } from 'vue'
import router from './router.js'
import store from './store/index.js'
import App from './App.vue'
import BaseSpinner from './components/ui/BaseSpinner.vue'

// Define the feature flag
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true;

const app = createApp(App);

app.use(router);
app.use(store);

app.component('base-spinner', BaseSpinner);

app.mount('#app');
